import { render, staticRenderFns } from "./BusinessPanel.vue?vue&type=template&id=6c9e44df"
import script from "./BusinessPanel.vue?vue&type=script&lang=js"
export * from "./BusinessPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports